import { Component, ChangeDetectionStrategy, Input, Output, AfterViewInit, OnInit, EventEmitter, ViewChild } from "@angular/core";
import { ViewerBehaviourType } from "../../enums/viewer-behaviour-type";
import { E5coreUiEmailConversationViewerComponent } from "./component/e5core-ui-email-conversation-viewer.component"
import { ViewerDisplayEvent } from "../../events/viewer-display-event";
import { ViewerModel } from "../../models/viewer-model";
import { UiStyleService } from "../../services/ui-style.service";

@Component({
    selector: 'e5core-ui-conversation-viewer',
    template: `
    <span>
    <e5core-ui-email-conversation-viewer [behaviourType]="behaviourType" [popupWindowFeatures]="popupWindowFeatures" [readonly]="readonly" (viewerDisplayedEvent)="onViewerDisplayed($event)"></e5core-ui-email-conversation-viewer>
    </span>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiConversationViewerComponent implements AfterViewInit, OnInit {
    @Input() behaviourType : ViewerBehaviourType;
    @Input() popupWindowFeatures : string = "top=0,left=0,width=500,height=700,directories=no,location=no,menubar=no,status=no,resizable=yes,titlebar=yes,toolbar=no";
    @Input() readonly : boolean = false;
    @Output() viewerDisplayedEvent = new EventEmitter<ViewerDisplayEvent>();

    @ViewChild(E5coreUiEmailConversationViewerComponent)
    public emailConversationViewerComponent: E5coreUiEmailConversationViewerComponent;

    constructor(public style:UiStyleService) 
    {
    }

    ngOnInit() {
    }
      
    ngAfterViewInit() {
    }

    public showViewer(viewerModel : ViewerModel) : void {
        if (this.emailConversationViewerComponent == undefined)
          return;

        switch(+this.behaviourType) {
            case ViewerBehaviourType.Inline:
                this.emailConversationViewerComponent.showInlineViewer(viewerModel);
                break;
            case ViewerBehaviourType.Popup:
                this.emailConversationViewerComponent.showPopViewer(viewerModel);
                break;
        }
    }

    public onViewerDisplayed(event) : void {
        this.viewerDisplayedEvent.emit(event);
    }
}